import { RU_FEED } from '../lib/feedContext';
import { venueCanon } from './venues';
export const CUPIS_PAIR_BOOKS = { fonbet: 'Фонбет', winline: 'Винлайн', leon: 'Леон', olimp: 'Олимп', polymarket: 'Polymarket', kalshi: 'Kalshi' };
export type CupisPairMode = 'all' | 'russian' | 'poly' | 'selected';
export const RU_PAIR_BOOKS = { ...CUPIS_PAIR_BOOKS, betboom: 'BetBoom', onexbetru: '1xBet' };
const cupisRussian = new Set(['fonbet', 'winline', 'leon', 'olimp']);
const ruRussian = new Set([...cupisRussian, 'betboom', 'onexbetru']);
export const cupisPairKey = (a: string, b: string): string => [venueCanon(a), venueCanon(b)].sort().join('|');
export function cupisPairPass(sources: readonly string[], mode: CupisPairMode = 'all', selected: readonly string[] = []): boolean {
  const russian = RU_FEED ? ruRussian : cupisRussian;
  if (mode === 'all') return true;
  if (sources.length !== 2) return false;
  const [a, b] = sources.map(venueCanon);
  if (!a || !b || a === b) return false;
  if (mode === 'russian') return russian.has(a) && russian.has(b);
  if (mode === 'poly') return (['polymarket', 'kalshi'].includes(a) && russian.has(b)) || (['polymarket', 'kalshi'].includes(b) && russian.has(a));
  return selected.includes(cupisPairKey(a, b));
}
